import { useCallback, useRef } from 'react';
export const useEvent = (handler) => {
    const handlerRef = useRef(null);
    // @ts-expect-error ".current is mutable"
    handlerRef.current = handler;
    return useCallback((...args) => {
        // @ts-expect-error ".current is always defined"
        return handlerRef.current(...args);
    }, []);
};
//# sourceMappingURL=useEvent.js.map